var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"canvas-container"},[(_vm.graph.length !== 0)?_c('canvas',{ref:"canvas"}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }